import {Component, Inject, OnInit, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { CommonService } from '@app/feature/store-editor/services/common.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { IPageContent, ILayoutSettings } from '../../components/layout/store-editor.interface';

@Component({
  selector: 'app-sub-window-text',
  templateUrl: './sub-window-text.component.html',
  styleUrls: ['./sub-window-text.component.css']
})
export class SubWindowTextComponent implements OnInit {

  @Input() item: IPageContent;

  @Input() layoutSetting: ILayoutSettings;
  initControls: any;
  public options: Object = {
    toolbarButtons: ['fontFamily', '|', 'fontSize', '|', 'paragraphFormat', '|', 'bold', 'italic', 'underline', 'undo', 'redo', 'formatOL', 'formatUL', 'outdent', 'indent', 'quote', '-', 'insertLink', 'insertImage', 'insertVideo'],
    fontFamilySelection: true,
    fontSizeSelection: true,
    paragraphFormatSelection: true,
    charCounterCount: false,
    placeholderText: 'Edit Your Content Here!',
    imageUpload: true,
    imageDefaultAlign: 'left',
    imageDefaultDisplay: 'inline-block',
    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,
    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    height: 350,
    imageEditButtons: ['imageDisplay', 'imageAlign', 'imageInfo', 'imageRemove'],
    events: {
      'image.beforeUpload': (images: any) => {

        const editor = this.initControls.getEditor();
        this.cs.uploadFileBlob(images[0]).then(res => editor.image.insert(res, null, null, editor.image.get()));

        return false;
      }
    }
  };
 
  config: AngularEditorConfig = {
    editable: true, 
    spellcheck: true,
    height: '15rem',
    minHeight: '5rem',
    placeholder: 'Enter text here...',
    translate: 'no',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
   // toolbarHiddenButtons: [
     // ['bold']
  //  ],
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ]
  };
  constructor(public dialogRef: MatDialogRef<SubWindowTextComponent>,
    @Inject(MAT_DIALOG_DATA) public htmlContent: string, private cs: CommonService) {
  }

  public initialize(initControls: any) {
    this.initControls = initControls;
    this.initControls.initialize();
  
  }
  ngOnInit() {
    this.item.data = this.cs.setDefaultSetting(this.item.data);
    this.htmlContent = this.item.data.description;
  }

  onClose() {
   // this.item.data.description = this.htmlContent;
    this.dialogRef.close(this.htmlContent);
  }

}
